// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._19itglyw{border:none}._154ipxbi{top:var(--ds-space-200,1pc)}\n._1ltvpxbi{left:var(--ds-space-200,1pc)}\n._kqswstnw{position:absolute}", ""]);
// Exports
module.exports = exports;
